module.exports = __webpack_public_path__ + "static/content-blocks-call-to-action-0894770849728ffa277e99bfeed367ee.jpg";